export default __webpack_public_path__ + "static/media/documentation.ce6d0877.svg";